import React from "react";
import { UIButton } from "@/components/ui/button";
import { ButtonIconDownload } from "@/components/common/button/ButtonIconDownload";
import { cn } from "@/lib/utils";

export interface DownloadAttachmentButtonProps extends React.ComponentProps<typeof UIButton> {
  variant?: "default" | "outline" | "ghost";
  label?: string;
}

export const DownloadAttachmentButton: React.FC<DownloadAttachmentButtonProps> = ({
  children,
  className,
  label,
  ...props
}) => {
  return (
    <UIButton
      className={cn(className, "flex items-center gap-2 cursor-pointer bg-primary-700 hover:bg-primary-800")}
      variant="default"
      {...props}
    >
      <ButtonIconDownload style={{ marginRight: 8 }} />
      {children || label}
    </UIButton>
  );
};

export default DownloadAttachmentButton;
